<template>
  <div class="back-to-top">
    <button
      class="clickable"
      @click="scrollToTop"
    >
      <span class="body-4">
        {{ $t('reusable.backToTop') }}
      </span>
      <img
        class="icon"
        alt="Back to Top Icon"
        src="~/assets/icons/arrow-up-blue.svg"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
  defineProps({
    scrollOffset: {
      type: Number,
      default: 300
    }
  })

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .back-to-top {
    display: flex;
    justify-content: flex-end;

    margin: rem(24) auto;

    @include tablet-up {
      padding: 0 rem(20);
    }

    .clickable {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;
      cursor: pointer;
      border: none;
      background-color: transparent;
      color: $bt-blue;
    }

    .icon {
      border: 1px solid $ui-light-blue;
      border-radius: 50%;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding: rem(15) rem(14);
      height: 20px;
      width: 22px;
    }
  }
</style>
